import React from "react";
import Select from "react-select";
import { SelectWrapper } from "./styles";
import { StyledSelectProps } from "./types";

// https://react-select.com/styles#styles
export const StyledSelect: React.FC<StyledSelectProps> = ({
  options,
  handleChange,
  value,
  testId,
  disabled,
  ariaLabel,
}) => {
  return (
    <SelectWrapper data-testid={testId}>
      <Select
        isDisabled={disabled}
        value={value}
        options={options}
        onChange={handleChange}
        inputId={testId}
        aria-label={ariaLabel}
        classNamePrefix="select"
        menuPortalTarget={document.body}
        styles={{
          control: (baseStyles: any, state: any) => ({
            ...baseStyles,
            fontWeight: 500,
            fontSize: "var(--text-base)",
            padding: "0px 6px",
            height: "28px !important",
            borderRadius: "0.5rem",
            borderColor: state.isDisabled
              ? "var(--color-border)"
              : "var(--color-gray-border)",
            background: state.isDisabled
              ? "var(--color-background-disabled)"
              : "var(--color-card-background)",
            color: state.isDisabled
              ? "var(--color-text-secondary)"
              : "var(--color-text-default)",
            boxShadow: "none",
            cursor: state.isDisabled ? "not-allowed" : "pointer",

            "&:hover": {
              borderColor: state.isDisabled
                ? "var(--color-border)"
                : "var(--color-gray-700)",
            },

            "&:active": {
              borderColor: "var(--color-gray-700)",
            },
          }),
          option: (baseStyles: any, state: any) => ({
            ...baseStyles,
            borderRadius: "0.5rem",
            background: "var(--color-background-2)",
            color: "var(--color-text-default)",
            fontWeight: 500,
            fontSize: "var(--text-base)",

            "&:hover": {
              background: "var(--gradient-primary)",
              color: "var(--color-white)",
            },
          }),
          menu: (baseStyles: any, state: any) => ({
            ...baseStyles,
            borderRadius: "0.5rem",
            fontWeight: 500,
            fontSize: "var(--text-base)",
            background: "var(--color-background-2)",
          }),
          singleValue: (baseStyles: any, state: any) => ({
            ...baseStyles,
            fontWeight: 500,
            fontSize: "var(--text-base)",
            color: "var(--color-text-default)",
          }),
          input: (baseStyles: any, state: any) => ({
            ...baseStyles,
            fontWeight: 500,
            fontSize: "var(--text-base)",
            color: "var(--color-text-default)",
          }),
        }}
      />
    </SelectWrapper>
  );
};
